// export const GA93_TRACKING_ID: string = process.env.NEXT_PUBLIC_GTM_OLD || '';
export const GA94_TRACKING_ID: string = process.env.NEXT_PUBLIC_GTM_NEW || '';

export const pageview: Function = (url: string) => {
    (window as any).gtag('config', GA94_TRACKING_ID, {
        page_path: url,
    });
    // (window as any).gtag('config', GA93_TRACKING_ID, {
    //     page_path: url,
    // });
};

export const event: Function = ({
    event,
    action,
    category,
    label,
    source,
    value,
}: any) => {
    (window as any).gtag('event', {
        event: event,
        event_action: action,
        event_category: category,
        event_label: label,
        event_source: source,
        ...value,
    });
};

export const dataLayerPush: Function = (data: any) => {
    if (window) (window as any)?.dataLayer?.push(data);
};

const gtag = {
    pageview,
    event,
    dataLayerPush,
};

export default gtag;
